import { useParams, useNavigate } from 'react-router-dom'
import { useApi } from '../index'
import type { GccS0bReview } from '@shared/types'
import GccTaskRegisterReview from './GccTaskRegisterReview'

export default function GccTaskRegisterReviewPage() {
  const { projectId } = useParams<{ projectId: string }>()
  const navigate = useNavigate()
  const api = useApi()

  if (!projectId) return null

  const handleConfirm = async (review: GccS0bReview) => {
    const project = await api.getProject(projectId)
    if (project?.gccData) {
      await api.saveProject({
        ...project,
        gccData: { ...project.gccData, s0bReview: review },
        updatedAt: new Date().toISOString(),
      })
    }
    navigate(`/gcc/dashboard/${projectId}`)
  }

  const handleSkip = () => {
    navigate(`/gcc/dashboard/${projectId}`)
  }

  return (
    <div className="min-h-full bg-gray-50 py-8">
      <GccTaskRegisterReview
        projectId={projectId}
        onConfirm={handleConfirm}
        onSkip={handleSkip}
      />
    </div>
  )
}
